<app-toolbar (openSideMenu)="showSideMenu = true"></app-toolbar>
<!-- Shows at hamburger click -->
<app-side-menu [style.display]="showSideMenu ? null : 'none'" (closeSideMenu)="showSideMenu = false">
</app-side-menu>